module.exports = __webpack_public_path__ + "img/invite-import.28f0b4a9.webp";